import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION,

    IPatientLoadFailureAction,
    IPatientLoadSuccessAction,

    LoadSuccess,
    LoadFailure,
    IPatientLoadByTrialInstitutionAction,

} from "../actions/patients";
import { patientsApi } from "../services/patients";


export const
    getPatientByIdEpic = (action$): Observable<IPatientLoadSuccessAction | IPatientLoadFailureAction> => {
        return action$
            .ofType(ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION)
            .mergeMap((action: IPatientLoadByTrialInstitutionAction) => {
                return patientsApi
                    .getPatientByTrialInstitution(action.trialId, action.institutionId)
                    .map(response => LoadSuccess(response.patients, response.responseStatus))
                    .catch(error => Observable.of(LoadFailure(error.responseStatus)))
            });
    }